import apiurl from './apiurl';
const axios = require('axios');

const empresas = {
    getEmpresas: async (idToken) =>
        axios({
            'method': 'GET',
            'url': apiurl + 'empresas',
            'headers': {
                'content-type': 'application/json',
                'Authorization': "Bearer " + idToken
            },
            'crossdomain': true,
        }),

    createEmpresa: async (body, idToken) =>
        axios({
            method: 'POST',
            url: apiurl + 'empresas',
            headers: {
                'content-type': 'application/json',
                'Authorization': "Bearer " + idToken
            },
            data: body,
            crossdomain: true,
        })

};

export default empresas;
